import React from "react";

const AnimationWrapper = React.forwardRef(({children, ...props}: {children: React.ReactNode}, ref: React.ForwardedRef<HTMLDivElement>) => {
    return <div ref={ref} {...props}>
        {children}
    </div>
})
export default AnimationWrapper;